import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import ListOfImage from './ListOfImages';

const ImageGalleryContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Gallery' parent='Gallery' title='Gallery' />
      <Row>
        <ListOfImage />
      </Row>
    </Container>
  );
};

export default ImageGalleryContainer;
